import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { MapService } from '../map.service';
import { AppService } from '../app.service';
import { GeoJson, FeatureCollection} from '../map';
//import * as MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';


@Component({
  selector: 'map-box',
  templateUrl: './map-box.component.html',
  styleUrls: ['./map-box.component.css']
})

export class MapBoxComponent implements OnInit {

	map: mapboxgl.Map;
	style = 'mapbox://styles/mapbox/outdoors-v9';
	lng = -2.047919;
	lat = 42.383986;
	message = 'Map from Sartaguda';
  popup = new mapboxgl.Popup({closeButton: false, closeOnClick: false, offset: 30});

	// data
	source: any;
	markers: any;
	hoverid: null;
	activeMarker: any;
  newMarker: any;
  lang: string;

  constructor(
		private mapService: MapService,
		public appService: AppService,
    @Inject(LOCALE_ID) protected localeId: string
		) { }

  ngOnInit() {
		this.initializeMap()
    this.lang = this.localeId;
  }

	private initializeMap() {
		this.markers = this.mapService.getMarkers()
		this.buildMap()
	}

  public cleanMarker() {
    if (this.activeMarker!=undefined) this.activeMarker.remove()
  }

	buildMap() {
		this.map = new mapboxgl.Map({
			container: 'map',
		  //style: 'mapbox://styles/mapbox/outdoors-v9',
			style: 'mapbox://styles/lrullo/cjm4bqlj2b36y2ss4mpq41uxs',
			zoom: 13,
			pitch: 60, // pitch in degrees
    	bearing: 0, // bearing in degrees
			center: [this.lng, this.lat],

		});

		// controls
		this.map.addControl(new mapboxgl.NavigationControl())
		// this.map.addControl(new MapboxGeocoder({
    // 	accessToken: mapboxgl.accessToken
		// }));


    let feed = "http://www.soinumapa.net/geojson/"
    /*mapboxgl.util.getJSON(feed, (err,data) => {
      this.map.addSource('soinumapa', {
        type:'geojson',
        data: data,
        cluster:true,
        clusterMaxZoom:30,
        clusterRadius: 50
      })*/


		this.map.on('click','clusters', (event) => {
			let features = this.map.queryRenderedFeatures(event.point, { layers: ['clusters'] });
      let clusterId = features[0].properties.cluster_id;
			this.map.getSource('soinumapa').getClusterExpansionZoom(clusterId, (err,zoom) => {
				if (err) return
				this.map.easeTo({
					center: features[0].geometry.coordinates,
					zoom: zoom
				});
			})
		})
    //
    // this.map.on('contextmenu',(event)=> {
    //   if (this.newMarker!=undefined) this.newMarker.remove()
    //
    //   var features = this.map.queryRenderedFeatures(event.point, {layers:['clusters','soinumapa']});
    //   //console.log(features);
    //   if (features.length==0) {
    //     var el = document.createElement('div');
    //     el.className = 'marker new-marker';
    //     const coordinates = [event.lngLat.lng, event.lngLat.lat]
		// 	  // const newMarker = new GeoJson(coordinates, { message : 'new marker' })
    //     this.appService.addMarker('new marker',coordinates)
    //     this.newMarker = new mapboxgl.Marker(el)
  	// 			.setLngLat(coordinates)
  	// 			.addTo(this.map);
    //   }
    //   //console.log(event)
    // })

    this.map.on('mousemove','soinumapa', (e) => {
      if (e.features.length > 0) {
        var coord = e.features[0].geometry.coordinates.slice();
        while (Math.abs(e.lngLat.lng - coord[0]) > 180) {
            coord[0] += e.lngLat.lng > coord[0] ? 360 : -360;
        }
        this.popup.setLngLat(coord)
          .setHTML(e.features[0].properties.title)
          .addTo(this.map)
      }
    })

    this.map.on('mouseleave','soinumapa', (e) => {
      this.popup.remove();
    })

		this.map.on('click','soinumapa', (event) => {
			// clean old markers
			//let m = document.getElementsByClassName('active-marker')
			//if (m.length > 0) document.removeChild(m[0])

			if (this.activeMarker!=undefined) this.activeMarker.remove()

			const coordinates = [event.lngLat.lng, event.lngLat.lat]
			//const newMarker = new GeoJson(coordinates, { message : 'new marker' })
      //this.appService.addMarker('new marker',newMarker)

			let content = event.features[0].properties.content
			let title = event.features[0].properties.title
			let url = event.features[0].properties.attachment
			let	author = event.features[0].properties.author
			let category = event.features[0].properties.category
			let date = event.features[0].properties.date
      let imageURL = event.features[0].properties["image-url"]
			//console.log(event.features[0].properties)
			let info = "<h2>"+title+"</h2>"+imageURL+"<h3>"+author+"</h3><p>"+date+"</p>"+content+"<br/><audio class=\"marker-player\" controls autoplay src=\""+url+"\"></audio>"
			//console.log(event.features[0]);
			this.appService.clear()
			this.appService.add(info)

			var el = document.createElement('div');
			el.className = 'marker active-marker';
			this.activeMarker = new mapboxgl.Marker(el)
				.setLngLat(event.features[0].geometry.coordinates)
				.addTo(this.map);
		})

		this.map.on('mouseenter',"clusters", (event) => {
			this.map.getCanvas().style.cursor = 'pointer';
		});

		this.map.on('mouseenter','soinumapa', (event) => {
			this.map.getCanvas().style.cursor = 'pointer';
			let id = event.features[0].properties.id
			this.map.setFeatureState({source:'soinumapa',id: id}, { hover:true })
			this.hoverid = id
		})

		this.map.on("mouseleave", "clusters", () => {
			this.map.getCanvas().style.cursor = '';
		});

		this.map.on("mouseleave", "soinumapa", () => {
      this.map.getCanvas().style.cursor = '';
      if (this.hoverid) this.map.setFeatureState({source: 'soinumapa', id: this.hoverid}, { hover: false});
			this.hoverid = null
    });

		this.map.on('load',(event) => {
      this.map.addSource('soinumapa', {
 				type: 'geojson',
 				data: mapboxgl.geojson,
 				cluster: true,
 				clusterMaxZoom: 40,
 				clusterRadius: 30,
       })

			this.map.addLayer({
        id: "clusters",
        type: "circle",
        source: "soinumapa",
        filter: ["has", "point_count"],
        paint: {
            "circle-color": [
                "step",
                ["get", "point_count"],
                "#e5c126",
                5,
                "#e5c53c",
                10,
                "#f46a40"
            ],
            "circle-blur": 0.3,
            "circle-radius": [
                "step",
                ["get", "point_count"],
								20,
								3,
                30,
                5,
								40,
								7,
								50,
								10,
                60,
                750,
                80
            ]
        }
    	});
			this.map.addLayer({
        id: "cluster-count",
        type: "symbol",
        source: "soinumapa",
        filter: ["has", "point_count"],
        layout: {
            "text-field": "{point_count_abbreviated}",
            "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
            "text-size": 12
        }
    	});
			this.map.loadImage('assets/icon-red.png', (error,image) => {
				if (error) throw error;
				this.map.addImage('icon-red',image);
				this.map.addLayer({
					id: "soinumapa",
					source: "soinumapa",
					type: "symbol",
	        filter: ["!", ["has", "point_count"]],
					layout: {
            'icon-allow-overlap' : true,
            'icon-image': "icon-red",
						'icon-size': 1,
        	},
					paint: {
						'icon-opacity': ["case",
							["boolean", ["feature-state", "hover"], false],
							0.5,
							1
						]

					}
				})
			}) //load image
		})
	}

}

/* DOCUMENTATION */
/*----
https://www.mapbox.com/help/working-with-large-geojson-data/
https://www.mapbox.com/mapbox-gl-js/example/cluster/
https://www.mapbox.com/mapbox-gl-js/example/popup-on-hover/
https://www.mapbox.com/mapbox-gl-js/example/hover-styles/
https://angularfirebase.com/lessons/build-realtime-maps-in-angular-with-mapbox-gl/
----*/



// WEBPACK FOOTER //
// ./src/app/map-box/map-box.component.ts